<template>
  <section class="layout-section">
    <article
      v-for="({ thumbnail, name, description, siteLink }, slug, index) in conferences"
      :key="slug"
      class="layout-section__flex"
    >
      <figure
        v-appear="{ delay: index ? 0 : [$scroll, 900], threshold: 0, offset: 0 }"
        class="layout-section__figure -small -overlay"
        :style="{ '--image': `url('${thumbnail}')` }"
      >
        <img
          :src="`/images/events/${slugToKey(slug)}/logo-overlay-${$i18n.locale}.png`"
          :alt="name"
          class="layout-section__logo"
        />
      </figure>

      <section class="layout-section__content">
        <h4 v-appear:left="{ delay: index ? 0 : [$scroll, 950, 50] }" class="layout-section__subtitle">{{ name }}</h4>
        <p v-appear="{ delay: index ? 0 : [$scroll, 1000, 100] }">{{ description }}</p>

        <div v-appear="{ delay: index ? 0 : [$scroll, 1050, 150] }" class="layout-section__cta">
          <LocaleLink :to="{ name: 'conference', params: { slug } }" class="button -secondary">
            {{ $t('common.cta.learnMore') }}
          </LocaleLink>

          <a v-if="siteLink" :href="siteLink" target="_blank" class="button">{{ $t('common.navigation.eventNext') }}</a>
        </div>
      </section>
    </article>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EventsIndex',
  computed: {
    conferences() {
      return this.$i18n.messages[this.$i18n.locale].events.conferences.reduce((conferences, conferenceId) => {
        const [slug, conference] = Object.entries(this.$i18n.messages[this.$i18n.locale].conferences).find(
          keyPair => keyPair[1].id === conferenceId
        )

        if (!conference) return conferences
        const { siteLink = null } = Array.isArray(conference.events)
          ? conference.events.find(({ startDate }) => moment(startDate).isAfter(moment())) || {}
          : {}

        return { ...conferences, [slug]: { ...conference, siteLink } }
      }, {})
    }
  },
  methods: {
    slugToKey(slug) {
      return slug.replace(/-(.)/g, (_, letter) => letter.toUpperCase())
    }
  }
}
</script>
